export const ro = {
  // Header
  header: {
    museumName: "Muzeul Antipa",
    audioTour: "Tur Audio",
    progress: "Progres",
    credits: "Info",
  },

  // Sidebar
  sidebar: {
    tourModes: {
      guided: "Tur Ghidat",
      free: "Explorare Liberă",
    },
    audio: {
      available: "Audio Disponibil",
      notAvailable: "Audio Indisponibil",
      forAudioView: "Această expoziție este pentru audio-vizualizare.",
      forViewingOnly: "Această expoziție este doar pentru vizualizare.",
      noAudio: "Fără audio",
    },
    visited: {
      markAsVisited: "Marchează ca Vizitat",
      markAsUnvisited: "Marchează ca Nevizitat",
    },
    allExhibits: "Toate Expozițiile",
  },

  // Stats Modal
  statsModal: {
    title: "Progresul Turului",
    complete: "Complet",
    unvisitedExhibits: "Expoziții Nevizitate",
    allExhibitsVisited: "Toate expozițiile au fost vizitate!",
    markAsCompleted: "Marchează ca Finalizat",
    restartTour: "Restart Tur",
  },

  // Museum Map
  museumMap: {
    customMap: "Hartă Personalizată a Muzeului",
    artistDesign: "Designul artistului va fi plasat aici",
    noAudio: "Fără audio",
    autoCenterDisabled: "Centrare automată dezactivată",
  },

  // Exhibits Data
  exhibits: {
    1: {
      title: "Marea Neagră",
      description: "În ritmul valurilor.",
      zone: "Biodiversitatea României",
    },
    2: {
      title: "Delta Dunării",
      description: "\"Paradisul păsărilor\".",
      zone: "Biodiversitatea României",
    },
    3: {
      title: "Zona silvostepă și continentală",
      description: "Sunetele naturii din păduri și câmpii.",
      zone: "Biodiversitatea României",
    },
    4: {
      title: "Cerbul atacat de lupi",
      description: "Viața sălbatică în acțiune.",
      zone: "Biodiversitatea României",
    },
    5: {
      title: "Carpații României",
      description: "Munții care prind viață.",
      zone: "Biodiversitatea României",
    },
    6: {
      title: "Arctica și Antarctica",
      description: "Viața la poli.",
      zone: "Biodiversitatea Terrei",
    },
    7: {
      title: "Bioregiuni terestre",
      description: "Jungla sud-americană, Pampas și Madagascar.",
      zone: "Biodiversitatea Terrei",
    },
    8: {
      title: "Bioregiunea orientală",
      description: "Călătorind prin Asia sudică și Sud-Estică.",
      zone: "Biodiversitatea Terrei",
    },
    9: {
      title: "Bioregiunea australiană și neozeelandeză",
      description: "Australia. Noua Guinee. Noua Zeelandă.",
      zone: "Biodiversitatea Terrei",
    },
    10: {
      title: "Africa",
      description: "Savana în mișcare.",
      zone: "Biodiversitatea Terrei",
    },
  },

  // Credits Screen
  credits: {
    title: "Credite",
    subtitle: "Tur Audio",
    description: "Experiență Audio Interactivă",
    close: "Închide",
    fundingDisclaimer: "\"Antipa Acoustic\" - proiectul cultural este co-finanțat de Administrația Fondului Cultural Național (AFCN). Proiectul nu reprezintă în mod necesar poziția Administrației Fondului Cultural Național. AFCN nu este responsabilă de conținutul proiectului sau de modul în care rezultatele proiectului pot fi folosite. Acestea sunt în întregime responsabilitatea beneficiarului finanțării.",
  },

  // Common
  common: {
    close: "✕",
    loading: "Se încarcă...",
    error: "Eroare",
    success: "Succes",
  },
};

export type Locale = typeof ro; 